import type { MetaDescriptor } from '@remix-run/node';
import { buildMeta } from '~/lib/seo';

export const metaHome = (): MetaDescriptor[] =>
  buildMeta({
    title: 'Home',
    description:
      'Magic is reawakening. Choose a faction and shape the fate of the world in Lumora: The First Dawn.',
  });

export const metaBlogIndex = (): MetaDescriptor[] =>
  buildMeta({
    title: 'Development Blog',
    description:
      'Developer updates, lore drops, and behind-the-scenes insights from the Lumora team.',
    canonical: 'https://www.lumora.com/blog',
  });

export const metaDatabaseIndex = (): MetaDescriptor[] =>
  buildMeta({
    title: 'Game Database',
    description:
      'Reference hub for Lumora items, skills, classes, and enemies with data-rich entries.',
    canonical: 'https://www.lumora.com/database',
  });

export const metaDocsIndex = (): MetaDescriptor[] =>
  buildMeta({
    title: 'Documentation',
    description: 'Comprehensive guides and lore documentation for Lumora: The First Dawn.',
    canonical: 'https://www.lumora.com/docs',
  });

export const metaMediaIndex = (): MetaDescriptor[] =>
  buildMeta({
    title: 'Media Hub',
    description: 'Screenshots, key art, and videos highlighting the world of Lumora.',
    canonical: 'https://www.lumora.com/media',
  });
